<template>
    <el-form-item :label="$t('storeModules.operationLog.operator')">
        <el-select :placeholder="$t('common.pleaseSelect')" @change="selectChange" v-model="operate_id" clearable
            filterable remote :remote-method="remoteMethod" style="width: 100%">
            <el-option v-for="item in options" :label="item.label" :value="item.value" :key="item.value"></el-option>
        </el-select>
    </el-form-item>
</template>

<script setup>
import { onMounted, ref, watch } from 'vue'
import { getOperationList } from '@/api/common'

const props = defineProps({
    modelValue: {
        type: [String, Number],
        default: ''
    }
})
const operate_id = ref(props.modelValue),
    options = ref([]),
    emit = defineEmits(['change', 'update:modelValue'])

watch(() => props.modelValue, (val) => {
    operate_id.value = val
})

onMounted(() => {
    getList()
})

const remoteMethod = (query) => {
    getList(query)
}

async function getList(name) {
    const params = {
        name,
        page: 1,
        size: 10,
    }
    const { result } = await getOperationList(params)
    if (result) {
        options.value = result.data.rows.map((item) => {
            return {
                value: item.id,
                label: item.name,
            }
        })
    }
}

function clear() {
    operate_id.value = undefined
}

function selectChange(e) {
    emit('change', e)
    emit('update:modelValue', e)
}

defineExpose({
    clear,
})
</script>

<style lang="scss" scoped></style>
